import NAME from "./constants";

export const getProgressIsOpen = store => store[NAME].open;
export const getProgressValue = store => store[NAME].value;